import colors from "../styles/_variables.scss";

export const userSelectColors = Object.values(colors);

export const defaultUserSelectColor = "blue";

export function getSelectableColorCodeByName(name) {
  const [color, value] = 
    getUserSelectColors((pair) => pair[0].includes(name));

  return value ?? colors[`userSelectColors-${defaultUserSelectColor}`];
}

export function getSelectableNameByCode(code) {
  const [color, value] = 
    getUserSelectColors(pair => pair[1] === code);
    
  if (!color) {
    return defaultUserSelectColor;
  }  

  return color.replace("userSelectColors-", "");
}


function getUserSelectColors(findBy) {
  const entries =  
    Object.entries(colors)
      .filter(key => key[0].includes("userSelectColors"));

  const entry = entries.find(keyValue => findBy(keyValue));

  console.log(entries, entry)

  return entry ?? [];
}